/**
 * index.ts — Ponto de entrada único do Studio Core
 *
 * Importar SEMPRE por aqui (`@/lib/studio/core`) garante que os registros de
 * blocos, contextos e tipos de modelo já estejam carregados. Este módulo é
 * neutro (sem DOM, React, Node ou Deno) e é a única fonte de verdade
 * compartilhada entre o aplicativo e as Edge Functions.
 *
 * RELEASE: v1.1.0 - 2026-09-11 - Blocos interativos passam a ser registrados
 *          antes da decoração e da direção de arte, recebendo o mesmo contrato
 *          avançado dos demais blocos.
 * RELEASE: v1.0.0 - 2026-09-09 - Versão inicial (Studio, Fase 1)
 */

// Efeitos colaterais de registro (ordem importa: blocos e contextos primeiro)
import './blockRegistry';
import './blocks/sections';
import './blocks/primitives';
// Contêiner vertical (vocabulário editorial): agrupa blocos dentro de uma coluna.
import './blocks/layout';

import './blocks/proposal';
import './blocks/page';
// Seção em HTML livre (páginas criadas por IA e importadas como blocos)
import './blocks/htmlSection';
import './contexts/proposal';
import './templateDefinitions';
import './patterns/catalog';
import './patterns/heroes';
// Lote A do motor de modelos — categorias reconstruídas no padrão premium
import './patterns/textoImagem';
import './patterns/recursos';
import './patterns/numeros';
import './patterns/depoimentos';
import './patterns/logos';
import './patterns/galeria';
// Lote B do motor de modelos — categorias reconstruídas no padrão premium
import './patterns/precos';
import './patterns/faq';
import './patterns/etapas';
import './patterns/equipe';
import './patterns/cta';
import './patterns/formulario';
// Lote C do motor de modelos — categorias reconstruídas no padrão premium
import './patterns/menu';
import './patterns/titulos';
import './patterns/texto';
import './patterns/video';
import './patterns/contato';
import './patterns/rodape';
import './patterns/separadores';
// Modelos que estreiam máscaras, inclinação, formas e efeitos (v1.7.0).
import './patterns/premium';
// Modelos no vocabulário editorial (empilhamento, ícones e cartões numerados).
import './patterns/editorial';
// Composições com espaços semânticos (Fase 8)
import './compositions/library';
import './blocks/interactive';
// Fundos decorativos e acabamentos de borda: aplicados sobre TODOS os blocos.
import './blocks/decor';
// Direção de arte por tela (Fase 7): aplicada sobre TODOS os blocos já registrados.
import './blocks/screen';

export * from './types';
export * from './blocks/page';
export * from './blockRegistry';
export * from './contextRegistry';
export * from './templateDefinitions';
export * from './formatters';
export * from './validate';
export * from './patterns/types';
export * from './patterns/patternRegistry';
export * from './compositions/types';
export * from './compositions/compositionRegistry';


import { STUDIO_SCHEMA_VERSION, type StudioDocument } from './types';

/** Documento vazio, usado ao criar um modelo novo. */
export function createEmptyDocument(): StudioDocument {
  return {
    schemaVersion: STUDIO_SCHEMA_VERSION,
    blocks: [],
    theme: {},
    settings: {},
  };
}
